const KEY_ARGS = ["q", "filters", "connection"];

/**
 * Apollo field policy of `ecolixExplorerOrders`
 *
 * Like the other infinite lists, "voir plus" (offset > 0) appends to what is
 * shown. Unlike them, a first page replaces it: after "Rafraîchir" the copy
 * may have lost orders and gained new ones on top, and appending the refetch
 * would keep the gone ones and push the new ones to the bottom.
 */
export default {
  // each filter set, search and connection is its own list
  keyArgs: (args) =>
    KEY_ARGS.filter((key) =>
      Object.prototype.hasOwnProperty.call(args || {}, key)
    ),
  merge(existing, incoming, { args } = {}) {
    if (!existing || !args || !args.offset) {
      return incoming;
    }

    return {
      ...incoming,
      data: [...existing.data, ...incoming.data].filter(
        (current, index, array) =>
          array.findIndex((value) => value.__ref === current.__ref) === index
      ),
    };
  },
};
